
/* injects from baggage-loader */
require('./style.scss');

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { t } from '../../../../../helpers/translator';
import StaticStake from '../../../../components/staticStake';
import Keyboard from '../../../../components/virtualKeyboard';
import { roundStake } from '../../../../../helpers/sport/betslip';
import { GetCurrencyConfig, GetTerminalBalance, GetToken, GetUser } from '../../../../../helpers/selectors';
import MoneyAmount from '../../../../components/moneyAmount';
import Config from '../../../../../config/main';
import { betBuilderPlaceBet, betBuilderBookingBet, calculateBetBuilderPossibleWin } from './helpers';
import Zergling from '../../../../../helpers/zergling';
import { PrintBetBuilderTicket } from '../../../../../actions/terminal';
import { ClosePopup } from '../../../../../actions/ui';
import Helpers from '../../../../../helpers/helperFunctions';

const BetBuliderBetslip = ({ betData, onClear, user, terminalBalance, currencyConfig, token, partner, dispatch }) => {
    const [stake, setStake] = useState();
    const [placeBetError, setPlaceBetError] = useState();
    const [placeBetLoading, setPlaceBetLoading] = useState(false);
    const [keyboardSettings, setKeyboardSettings] = useState();
    const currency = JSON.parse(sessionStorage.getItem("authData")).currency;
    const currencyType = currency || user?.profile?.currency_id;
    const selectedCurrencyConfig = (currencyType && currencyConfig[currencyType]) || { rounding: Config.main.currencyRounding };

    const taxOnStake = useMemo(() => (partner.tax_percent * +stake / 100) || 0, [stake])
    const totalStake = useMemo(() => +stake && parseFloat(+stake - taxOnStake).toFixed(Math.abs(selectedCurrencyConfig.rounding)), [stake, taxOnStake, selectedCurrencyConfig])
    const possWin = useMemo(() => calculateBetBuilderPossibleWin(totalStake, betData.price, currencyConfig), [totalStake, betData, currencyConfig]);

    const taxType = useMemo(() =>
        partner?.tax_amount_ranges
            ? partner?.tax_amount_ranges[0]?.type
            : partner?.tax_type, [])

    const taxAmount = useMemo(() => stake && Helpers.calculateTaxForReturnedAndProfit(
        partner?.tax_percent,
        taxType === 2 ? possWin : possWin - totalStake,
        partner?.tax_amount_ranges
    ), [totalStake, possWin]);

    const placeBetDisabled = placeBetLoading || !stake || stake > terminalBalance;

    const toggleKeyboard = (e) => {
        if (keyboardSettings) {
            !e.defaultPrevented && setKeyboardSettings(null);
        }
        else {
            const keyboardSettings = {
                currentValue: stake,
                changeHandler: setStake,
                processHandler: stake => parseFloat(stake).toString() === stake ? roundStake(stake, currencyConfig.rounding) : stake,
                onCloseCallback: () => setKeyboardSettings(null),
                offset: e.target.offsetTop,
            }

            setKeyboardSettings(keyboardSettings);
        }
    };

    const placeBet = async () => {
        setPlaceBetLoading(true);

        const placeBetResponse = await betBuilderPlaceBet(betData.betslipUid, stake);
        if (!placeBetResponse) return

        if (placeBetResponse.data?.Id) {
            const ticketResult = await Zergling.checkTerminalBetTicket(placeBetResponse.data.Id * 10, token);

            ticketResult?.data && dispatch(PrintBetBuilderTicket(JSON.stringify({
                ...ticketResult.data,
                price: betData.formattedPrice,
            })));

            setPlaceBetError(null);
            dispatch(ClosePopup());
        } else {
            setPlaceBetError(placeBetResponse.data)
        }

        setPlaceBetLoading(false);
    }

    
    const booking = async () => {
        const bookingResponse = await betBuilderBookingBet(betData.betslipUid, stake);
        console.log(bookingResponse, '============bookingResponse');
    }

    return <div className="bet-builder-betslip">
        {keyboardSettings && <Keyboard
            settings={keyboardSettings}
            bindToElement={false}
        />}
        <div className="selections">
            <div className="selections-header">
                <div className="selection-header-left">
                    {t('Betslip')} <div className="count-badge-block">{betData.selections.length}</div>
                </div>
                <div className="selection-header-right">
                    <button className="selections-clear-all" onClick={onClear}>
                        <i className="global-icon icon-bin" />
                        {t('Clear All')}
                    </button>
                </div>
            </div>
            <div className="section-wrap">
                {betData.selections.map(item =>
                    <div key={item} className="selection"><span className="green-text">{item}</span></div>)
                }
            </div>
        </div>
        <div className="bet-info">
            <div className="bet-info-top">
                <div onClick={toggleKeyboard} className="single-form-item">
                    <span className="single-form-item-txt">{stake || t("Stake...")}</span>
                </div>
                <StaticStake
                    setStake={setStake}
                    activeStake={+stake}
                    user={user}
                    terminalBalance={terminalBalance}
                    currency={currency}
                />
            </div>
            <div className="bet-info-bottom">
                {
                    placeBetError && <div className="bet-info-text-block error">{placeBetError}</div>
                }
                {
                    stake && <div className="bet-info-text-block">{t('Stake:')}
                        <span>
                            <MoneyAmount amount={stake} />
                        </span>
                    </div>
                }
                <div className="bet-info-text-block">{t('Total Odd:')} <span className="green-text">{betData.formattedPrice}</span></div>
                {
                    !!Config.taxPercentOnStake && taxOnStake &&
                    <div className="bet-info-text-block">
                        {t("Tax on stake:")} {Config.taxPercentOnStake}{"%"}
                        <span>
                            <MoneyAmount amount={taxOnStake} />
                        </span>
                    </div>
                }
                {
                    !!Config.taxPercentOnStake && totalStake &&
                    <div className="bet-info-text-block">
                        {t("Total stake:")}
                        <span>
                            <MoneyAmount amount={totalStake} />
                        </span>
                    </div>
                }
                {!!possWin && <div className="bet-info-text-block">{t('Estimated return:')}
                    <span>
                        <MoneyAmount amount={possWin} />
                    </span>
                </div>}
                {!!taxAmount && <div className="bet-info-text-block">{t('Tax on Return:')}
                    <span>
                        <MoneyAmount amount={taxAmount} />
                    </span>
                </div>}
                {!!taxAmount && <div className="bet-info-text-block">{t('Total win:')}
                    <span>
                        <MoneyAmount amount={possWin - taxAmount} />
                    </span>
                </div>}
                <button disabled={placeBetDisabled} className="bet-info-place-bet-button" onClick={placeBet}>{t('Place-Bets')}</button>
                {/*<button className="bet-info-place-bet-button" onClick={booking}>{t('Booking')}</button>*/}
            </div>
        </div>
    </div>
};

BetBuliderBetslip.propTypes = {
    betData: PropTypes.object.isRequired,
    onClear: PropTypes.func.isRequired,
};

const mapStateToProps = () => (
    createSelector(
        [
            GetUser,
            GetCurrencyConfig,
            GetTerminalBalance,
            GetToken,
            state => state.swarmConfigData.partner,
        ],
        (user, currencyConfig, terminalBalance, token, partner) => ({
            user,
            currencyConfig,
            terminalBalance,
            token,
            partner
        }),
    )
);

export default connect(mapStateToProps)(BetBuliderBetslip);